import { ReservationReferenceIdentifier } from '@mews-commander/data-access';
import { Typography } from '@optimus-web/core';
import { useResolveRoute } from '@mews/routing';
import { DataTestId, RouteName } from '@mews-commander/enums';
import { intersperse } from '@mews/fp';
import { SpacedComma } from '@mews-commander/ui';
import { ModalLink } from '../../../../../components';

interface Props {
    reservations: ReservationReferenceIdentifier[];
}

export const ReservationReferenceLinks = ({ reservations }: Props) => {
    const reservationLinks = reservations.map((reservation) => (
        <ReservationReferenceLink key={reservation.reservationId} reservation={reservation} />
    ));

    const displayLinks = intersperse(SpacedComma, reservationLinks);

    return (
        <Typography as="span" textStyle="bodyMedium">
            {displayLinks}
        </Typography>
    );
};

const ReservationReferenceLink = ({
    reservation: { reservationId, reservationConfirmationNumber },
}: {
    reservation: ReservationReferenceIdentifier;
}) => {
    const resolveRoute = useResolveRoute();

    const routeName = resolveRoute(RouteName.ReservationDetail, { reservationId });

    return (
        <ModalLink data-service-order-link={reservationId} url={routeName} data-test-id={DataTestId.ReservationLink}>
            {reservationConfirmationNumber}
        </ModalLink>
    );
};
